




















import {Component, Vue} from "vue-property-decorator";
import {RhizomeViewType} from "@/modules/Rhizome/interfaces/state.interface";

@Component({})
export default class SwitchView extends Vue {
  viewTypes = RhizomeViewType;

  get activeView(): RhizomeViewType {
    return this.$store.state.rhizome.viewType;
  }

  set activeView(value: RhizomeViewType) {
    this.$store.commit('rhizome/setPropertyInState', { name: 'viewType', value })
  }

  switchView(type: RhizomeViewType) {
    this.activeView = type;
  }
}
